export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9552.0bdd6e5d.jpg";